// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EDswzt {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  height: 100%;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-xs);
  box-shadow: var(--card-box-shadow);
  overflow: hidden;
}

.YtcMoH {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: var(--spacing-2, 16px) var(--spacing-3, 24px) var(--spacing-3, 24px);
  gap: var(--spacing-3, 24px);
  flex: 1;
  min-height: 0;
  height: 100%;
}

.dXOnBW {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  padding: 0;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  width: 100%;
}

.RiuF2u {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  padding: 0;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-160);
  width: 100%;
}

.S4ugUI {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--text-neutral-medium);
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  text-align: center;
}

.wdgnrE {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  gap: var(--spacing-2, 16px);
  background-color: var(--surface-neutral-white);
  padding: 15px 0 0 0;
}

.Q3VuY1 {
  height: 40px;
  width: 100px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  background: var(--surface-neutral-white, #ffffff);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-primary-medium, #1f1f1f);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-md, 14px);
  cursor: pointer;
  transition: all 0.2s ease;
}

.Q3VuY1:hover {
  background: var(--surface-neutral-pale, #f5f5f5);
}

.PFqN1_ {
  height: 40px;
  width: 100px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  background: var(--brand-tr-orange, #d64000);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-neutral-white, #ffffff);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-md, 14px);
  cursor: pointer;
  transition: all 0.2s ease;
}

.PFqN1_:hover:not(:disabled) {
  background: var(--brand-tr-orange-dark, #b33600);
  border-color: var(--brand-tr-orange-dark, #b33600);
}

.PFqN1_:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: var(--disabled-subtle-surface, #f5f5f5);
  color: var(--text-neutral-strong, #666666);
  border: 2px solid var(--disabled-subtle-surface, #f5f5f5);
}

.qjKMGv {
  display: flex;
  justify-content: center;
  padding: var(--spacing-2, 16px) 0;
  margin-top: var(--spacing-1, 8px);
}

.us9S9S {
  min-width: 400px !important;
  max-width: 500px !important;
  width: auto !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixKeyCreation/PixKeyCreation.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,+BAA+B;EAC/B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,6EAA6E;EAC7E,2BAA2B;EAC3B,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,OAAO;EACP,UAAU;EACV,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,OAAO;EACP,UAAU;EACV,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uDAAuD;EACvD,+CAA+C;EAC/C,iDAAiD;EACjD,iDAAiD;EACjD,0CAA0C;EAC1C,oCAAoC;EACpC,6CAA6C;EAC7C,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uDAAuD;EACvD,+CAA+C;EAC/C,2CAA2C;EAC3C,iDAAiD;EACjD,yCAAyC;EACzC,oCAAoC;EACpC,6CAA6C;EAC7C,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,0CAA0C;EAC1C,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;AACxB","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  align-items: stretch;\n  width: 100%;\n  height: 100%;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-xs);\n  box-shadow: var(--card-box-shadow);\n  overflow: hidden;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  padding: var(--spacing-2, 16px) var(--spacing-3, 24px) var(--spacing-3, 24px);\n  gap: var(--spacing-3, 24px);\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n}\n\n.stepContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex: 1;\n  padding: 0;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  width: 100%;\n}\n\n.stepContainerConfirmation {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex: 1;\n  padding: 0;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-160);\n  width: 100%;\n}\n\n.placeholderContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  color: var(--text-neutral-medium);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-medium);\n  text-align: center;\n}\n\n.navigationButtons {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n  gap: var(--spacing-2, 16px);\n  background-color: var(--surface-neutral-white);\n  padding: 15px 0 0 0;\n}\n\n.backButton {\n  height: 40px;\n  width: 100px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  background: var(--surface-neutral-white, #ffffff);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-primary-medium, #1f1f1f);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-md, 14px);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.backButton:hover {\n  background: var(--surface-neutral-pale, #f5f5f5);\n}\n\n.nextButton {\n  height: 40px;\n  width: 100px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  background: var(--brand-tr-orange, #d64000);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-neutral-white, #ffffff);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-md, 14px);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.nextButton:hover:not(:disabled) {\n  background: var(--brand-tr-orange-dark, #b33600);\n  border-color: var(--brand-tr-orange-dark, #b33600);\n}\n\n.nextButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background: var(--disabled-subtle-surface, #f5f5f5);\n  color: var(--text-neutral-strong, #666666);\n  border: 2px solid var(--disabled-subtle-surface, #f5f5f5);\n}\n\n.errorActions {\n  display: flex;\n  justify-content: center;\n  padding: var(--spacing-2, 16px) 0;\n  margin-top: var(--spacing-1, 8px);\n}\n\n.pinErrorToast {\n  min-width: 400px !important;\n  max-width: 500px !important;\n  width: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EDswzt`,
	"content": `YtcMoH`,
	"stepContainer": `dXOnBW`,
	"stepContainerConfirmation": `RiuF2u`,
	"placeholderContent": `S4ugUI`,
	"navigationButtons": `wdgnrE`,
	"backButton": `Q3VuY1`,
	"nextButton": `PFqN1_`,
	"errorActions": `qjKMGv`,
	"pinErrorToast": `us9S9S`
};
module.exports = ___CSS_LOADER_EXPORT___;
